<template>
  <div class="conversion-wrapper" v-if="isFulfilled" @mouseenter="onMouseEnter">
    <div class="drip-h4 font-weight-bold color-noble-blue-500">
      {{ $t('dashboard.conversionRate.heading') }}
    </div>
    <div class="spacing-8"></div>
    <div
      class="rate-container d-flex flex-row align-items-center justify-content-start"
    >
      <div class="rate-left flex-1">
        <img
          src="@/assets/images/common/usa-flag.svg"
          alt="usa flag"
          class="mr-2"
        />
        {{ $t('dashboard.conversionRate.usd')
        }}{{ $t('dashboard.conversionRate.oneUSD') }}
      </div>
      <div class="flex-0 mx-3">
        <img src="@/assets/images/icons/equals.svg" alt="conversion equals" />
      </div>
      <div class="rate-right flex-1">
        <img
          src="@/assets/images/common/india-flag.svg"
          alt="india flag"
          class="mr-2"
        />
        <template>
          {{ $t('dashboard.conversionRate.inr') }}{{ rate }}
        </template>
      </div>
    </div>
    <div class="spacing-12"></div>
    <div class="info-text">
      <b-icon-info-circle scale="1.6" class="mr-2 color-sky-blue-color" />
      {{ $t('dashboard.conversionRate.note') }}
    </div>
    <div class="spacing-8"></div>
    <p class="drip-label font-weight-bold color-noble-blue-500 mb-0">
      {{ $t('dashboard.requestCallbackWidget.subHeader') }}
    </p>
    <div class="spacing-8"></div>

    <div v-if="!callbackMessageSent" class="d-flex">
      <action-button variant="text" :click="sentCallback" extraClass="px-3">
        <b-icon-arrow-repeat
          animation="spin"
          class="mr-3"
          v-if="callbackFulfilled"
        />
        <b-icon-telephone class="mr-3" v-else />
        {{ $t('dashboard.requestCallbackWidget.buttonText') }}
      </action-button>
    </div>

    <div class="success-message" v-if="callbackMessageSent === 'success'">
      <b-icon-check-circle
        font-scale="1.1"
        class="color-dark-green mr-3 align-self-start"
        scale="1.5"
      />
      <div>{{ $t('dashboard.requestCallbackWidget.successMessage') }}</div>
    </div>

    <div class="success-message error" v-if="callbackMessageSent === 'failed'">
      <b-icon-x-circle
        font-scale="1.1"
        class="mr-3 color-advanced-red"
        scale="1.5"
      />
      <div>{{ $t('dashboard.requestCallbackWidget.errorMessage') }}</div>
    </div>
  </div>
  <div v-else>
    <loader />
  </div>
</template>
<script>
import ActionButton from '@/components/common/ActionButton.vue'
import Loader from '@/components/common/Loader'
import exportersService from '@/services/exporters'

export default {
  props: {
    rate: String,
    isFulfilled: Boolean,
    isINREnabled: Boolean
  },
  data() {
    return {
      name: '',
      email: '',
      phone: '',
      callbackFulfilled: false,
      callbackMessageSent: false
    }
  },
  components: {
    Loader,
    ActionButton
  },
  mounted() {
    exportersService
      .fetchExporterMetaData(this.$store.state.account.accountId, {
        include: ['relationship_manager']
      })
      .then((res) => {
        const manager = res.data.relationship_manager
        if (manager) {
          this.name = manager.name
          this.email = manager.email
          this.phone = manager.phone
        }
      })
  },
  methods: {
    sentCallback() {
      if (!this.callbackFulfilled) {
        this.$mpTrack(
          'Clicks "Request a callback" on the "We can beat your bank rate!" tile'
        )
        const accountId = this.$store.state.account.accountId
        this.callbackFulfilled = true
        exportersService
          .requestAMCallback(accountId)
          .then((res) => {
            if (res.data === 'Slack Alert Sent') {
              this.callbackMessageSent = 'success'
            }
            if (res.data !== 'Slack Alert Sent') {
              this.callbackMessageSent = 'failed'
            }
            this.callbackFulfilled = false
          })
          .catch((err) => {
            console.log(err)
            this.callbackMessageSent = 'failed'
            this.callbackFulfilled = false
          })
      }
    },
    onMouseEnter() {
      this.$mpTrack('Mouse track on the currency conversion tile')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/_palette.scss';

.conversion-wrapper {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background: $sky-blue-50;
  padding: 12px 16px;
  margin: 0 auto;
  .rate-container {
    .rate-left,
    .rate-right {
      display: flex;
      align-items: center;
      font-size: 20px !important;
      background: $white;
      box-shadow: 0px 6px 12px rgba(10, 46, 87, 0.2);
      border-radius: 8px;
      font-weight: 700;
      line-height: 24px;
      color: $noble-blue-500;
      padding: 8px;
    }
  }
  .info-text {
    display: flex;
    font-weight: 500;
    font-size: 8px;
    line-height: 9px;
    margin-left: 4px;
    color: $noble-blue-500;
  }
  .success-message {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
    padding: 16px;
    color: $noble-blue-500;
    background: $spring-green-100;
    border: 1px solid $spring-green-600;
    border-radius: 8px;
    &.error {
      background: $red-100;
      border: 1px solid $red-400;
      align-items: center;
    }
  }
}
</style>
